import $ from "jquery";
import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { Button, Grid, Input } from 'semantic-ui-react';

import Server from '../../../functions/server';

class Title extends React.Component {

  state = {
    fullWidth: true, maxWidth: 'sm', name: '', mobile: '', address: '', taluk: '', district: '', state: '', pincode: ''
  }

  componentDidUpdate(props) {
    if (props.deliveryMasterId != this.props.deliveryMasterId) {
      this.getDetails(this.props.deliveryMasterId);
    }
  }

  getDetails(id) {
    let context = this;
    let data1 = { id };
    context.setState({ load: true, message: 'Getting details!!!' });
    $.ajax({
      type: 'POST', data: data1, url: Server() + 'deliverydetails/get.php',
      success: function(data) {
        console.log(data);
    
        try {
            data = JSON.parse(data);
            data.map((c) => {
                context.setState({ 
                    'masterId': id, 
                    'name': c.name, 
                    'mobile': c.mobile, 
                    'address': c.address, 
                    'taluk': c.taluk, 
                    'district': c.district, 
                    'state': c.state, 
                    'pincode': c.pincode 
                })
            })
        } catch (error) {
        }
      },
      error: function(err) {
        alert('Try Again!!!')
        context.setState({ load: false })
      }
    })
  }

  submit() {
    if (!this.props.menuPermission.edit) {
      alert('You Are Not Allow To Change Delivery Details!!!!');
      return;
    }
    let context = this;
    let { name, mobile, address, taluk, district, state, pincode, masterId } = this.state;
    let data1 = { name, mobile, address, taluk, district, state, pincode, masterId };
    $.ajax({
        type: 'POST', data: data1, url: Server() + 'deliverydetails/update.php',
        success: function(data) {
          if (data == 1) {
            alert('Saved');
            context.props.closeDeliveryDialog();
          }
          else {
            alert('Error to Save Data!!!')
          }
        },
        error: function(err) {
          alert('Try Again!!!')
          context.setState({ load: false })
        }
      })

  }

  handleChange = name => event => { this.setState({ [name]: event.target.value, }); }

  render() {
      let { name, mobile, address, taluk, district, state, pincode } = this.state;
    return (
      <div>
        <React.Fragment>
          <Dialog fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidth}  open={this.props.openDeliveryDialog}
            onClose={ () => { this.props.closeDeliveryDialog(); }} aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Delivery Details</DialogTitle>
            <DialogContent>
                <Grid>
                    <Grid.Column mobile={16} computer={8} tablet={16}>
                        Name
                        <Input fluid value={name} onChange={this.handleChange('name')} />
                    </Grid.Column>
                    <Grid.Column mobile={16} computer={8} tablet={16}>
                        Mobile                            
                        <Input fluid value={mobile} onChange={this.handleChange('mobile')} />
                    </Grid.Column>
                    <Grid.Column mobile={16} computer={16} tablet={16}>
                        Address
                        <Input fluid value={address} onChange={this.handleChange('address')} />
                    </Grid.Column>
                    <Grid.Column mobile={16} computer={8} tablet={16}>
                        Taluk
                        <Input fluid value={taluk} onChange={this.handleChange('taluk')} />
                    </Grid.Column>
                    <Grid.Column mobile={16} computer={8} tablet={16}>
                        district
                        <Input fluid value={district} onChange={this.handleChange('district')} />
                    </Grid.Column>
                    <Grid.Column mobile={16} computer={8} tablet={16}>
                        state
                        <Input fluid value={state} onChange={this.handleChange('state')} />
                     </Grid.Column>
                    <Grid.Column mobile={16} computer={8} tablet={16}>
                        Pincode
                        <Input fluid value={pincode} onChange={this.handleChange('pincode')} />
                    </Grid.Column>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button primary onClick={this.submit.bind(this)}>Submit</Button>
                <Button primary onClick={ () => { this.props.closeDeliveryDialog(); }}>Close</Button>
            </DialogActions>
          </Dialog>
        </React.Fragment>
      </div>
    );
  }
}

export default Title;
